// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentFooter_container__3VCI0","poweredByStripe":"PaymentFooter_poweredByStripe__3Ecxw","trialText":"PaymentFooter_trialText__Hwi8H"};